/**
 * Timeline scrubber slider for track replay.
 * Range input from 0 to frame count with current timestamp display.
 */

import { useReplayStore } from '@/stores/replay-store';

/** Draggable timeline scrubber for replay position */
export function TimelineScrubber(): React.JSX.Element {
  const { frames, currentIndex, seekTo } = useReplayStore();
  const maxIndex = Math.max(0, frames.length - 1);

  const startTime = frames[0]?.timestamp ?? '';
  const endTime = frames[maxIndex]?.timestamp ?? '';
  const currentTime = frames[currentIndex]?.timestamp ?? '';

  return (
    <div className="space-y-1">
      <input
        type="range"
        min={0}
        max={maxIndex}
        value={currentIndex}
        onChange={(e) => seekTo(Number(e.target.value))}
        className="w-full accent-echo-yellow"
      />
      <div className="flex justify-between text-[10px] text-muted-foreground">
        <span>{formatTimestamp(startTime)}</span>
        <span className="font-mono text-foreground">{formatTimestamp(currentTime)}</span>
        <span>{formatTimestamp(endTime)}</span>
      </div>
    </div>
  );
}

/** Format an ISO timestamp to a shorter display format */
function formatTimestamp(iso: string): string {
  if (!iso) return '--:--';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso.slice(11, 19);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
